// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wallet-transaction-wrapper {
  padding-top: 80px;
}

.wallet-transation-table-wrapper {
  margin-top: 65px;
}

.transactin-detail {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 27px;
}

.transactin-detail h2 {
  font-size: 34px;
  color: #383838;
  margin: 0px;
}

.transaction-detail-wrapper {
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
  margin-top: 43px;
}

.transaction-detail-wrapper span.time {
  margin-left: 15px;
}

/* .transaction-detail-wrapper h3 {
  width: 280px;
  font-size: 30px;
  color: #383838;
  padding-bottom: 10px;
  border-bottom: 5px solid #fbc425;
} */


.transactin-detail img {
  width: 35px;
  cursor: pointer;
}

.transaction-info-wrapper {
  margin-top: 36px;
}

.transaction-info-wrap {
  display: flex;
  gap: 90px;
  padding-bottom: 20px;
}

.transaction-info-wrap h5 span.highlight-text {
  color: #00A19B;
}

.transaction-info-wrap h4 {
  min-width: 220px;
  font-size: 24px;
  color: #383838;
  margin: 0px;
}

.transaction-info-wrap h5 {
  font-size: 24px;
  color: #5b5b5b;
  margin: 0px;
}

.transaction-detail-table-wrapper {
  margin-top: 100px;
  overflow-x: auto;
}

.transaction-total-wrapper {
  margin-top: 67px;
  padding-bottom: 50px;
}

.transaction-total-wrap {
  display: flex;
  justify-content: flex-end;
  gap: 150px;
  padding-bottom: 20px;
}

.transaction-total-wrap h4 {
  min-width: 165px;
  font-size: 24px;
  color: #383838;
  margin: 0px;
}

.transaction-total-wrap h5 {
  font-size: 24px;
  color: #5b5b5b;
  margin: 0px;
  min-width: 170px;
  width: 170px;
}

.transaction-detail-left {
  width: 60%;
}

.transaction-detail-right {
  width: 40%;
}

.transaction-with-icon{
  display: flex;
  align-items: center;
  gap: 8px;
}

.transaction-with-icon img {
  width: 30px;
}


.transaction-with-icon img.type-icon-img {
  width: 36px;
}

.transaction-banking-info-wrapper {
  margin-top: 62px;
}

h5.hyper-link-customer {
  color: #00A19B;
  cursor: pointer;
}

.contact-person-detail h4 {
  font-size: 16px;
  color: #00A19B;
  font-weight: 600;
  margin: 0px;
  padding-bottom: 10px;
}


.transation-cart-detail-wrap {
  margin-left: 56px;
  border-top: 1px dashed #ccc;
  padding-top: 40px;
  padding-bottom: 40px;
  display: grid;
  grid-template-columns: auto auto auto;
  gap: 50px;
}

.transation-cart-item-wrap h4 {
  font-size: 18px;
  font-weight: 700;
  margin: 0px;
  color: #1A1919;
  margin-bottom: 38px;
}

.cart-sqfeet-wrap {
  display: flex;
  justify-content: space-between;
}

.cart-sqfeet-wrap p{
  font-size: 14px;
  color: #1A1919;
  margin: 0px;
  font-weight: 400;
}



/****************** traking css ******/
.tranking-booking-cart-item {
  margin-top: 12px;
  text-align: right;
}


.booking-item-detail {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.booking-item-detail h6 {
  font-size: 14px;
  color: #1A1919;
  font-weight: 600;
  margin: 0px;
}

.booking-item-detail p{
  font-size: 14px;
  color: #1A1919;
  font-weight: 400;
  margin: 0px;
}

.booking-item-detail span{
  font-size: 14px;
  color: #00A19B;
  font-weight: 400;
  margin-top: 2px;
}


.booking-cart-item-repeat {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}


.tracking-order-main-wrap {
  margin-top: 45px;
}

.booking-cart-item-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.booking-cart-item-right {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.booking-item-price-wrap p {
  font-size: 14px;
  color: #1A1919;
  font-weight: 400;
  margin: 0px;
  min-width: 60px;
}

.booking-item-image {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #f3f3f3;
  overflow: hidden;
}

.booking-item-image img {
  width: 100%;
  object-fit: cover;
}

.tracking-address-detail-wrap {
  width: 100%;
  height: 402px;
  border: 2px solid #F8F8F8;
  border-radius: 34px;
  padding: 38px 38px;
  position: relative;
}

.tracking-address-detail-wrap h4 {
  font-size: 22px;
  color: #1A1919;
  font-weight: 600;
  margin: 0px;
}


.tracking-selected-services {
  display: flex;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
}

.tracking-selected-services img{
  width: 70px;
}

.tracking-selected-services p {
  font-size: 14px;
  color: #00A19B;
  font-weight: 600;
  margin: 0px;
}


.traking-detail-address-wrap{
  margin-top: 46px;
}

.traking-detail-address-wrap h4 {
  font-size: 16px;
  color: #1A1919;
  font-weight: 600;
  margin: 0px;
}

.tranking-address-confrim-icon img {
  width: 70px;
}

.tranking-address-confrim-icon {
  position: absolute;
  right: 20px;
  top: 30px;
}


.booking-item-quantity-wrap {
  width: 95px;
  height: 24px;
  border-radius: 12px;
  background: #F3F3F3;
  display: flex;
  align-items: center;
  justify-content: center;
}

.booking-item-quantity-wrap p {
  font-size: 14px;
  color: #1A1919;
  font-weight: 600;
  margin: 0px;
}

.booking-cart-items-wrap.tracking-cart-item-wrap h5 {
  font-size: 14px;
  color: #1A1919;
  font-weight: 600;
  margin: 0px;
  margin-top: 34px;
  margin-bottom: 13px;
}

.transation-cart-header h4 {
  font-size: 18px;
  color: #1A1919;
  font-weight: 700;
  margin: 0px;
}

.transation-cart-header{
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 28px;
}


.booking-cart-items-wrap.tracking-cart-item-wrap {
  height: calc(100vh - 600px);
  /* background-color: red; */
  overflow: auto;
  padding-right: 50px;
  border-right: 1px solid #ccc;
}

/******** track order css ****/

.order-track-status img {
  width: 35px;
  margin-left: -2px;
  margin-top: -4px;
}

.order-track-step {
  display: flex;
  height: 70px;
}



.order-track-long-step{
  height: 110px;
}

.order-track-step:last-child .order-track-status span:last-of-type {
  display: none;
}

.order-track-status {
  margin-right: 10px;
  position: relative;
  width: 30px;
}

.order-track-status-dot {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #00A19B;
  margin-left: 11px;
  position: inherit;
}

.order-track-status-line {
  display: block;
  margin: 0 auto;
  width: 0px;
  height: 70px;
  margin-top: -10px;
  border-left: 1px dashed #E1E1E1; 
  background: none;
}

.order-track-text {
  display: flex;
  flex-direction: column;
  gap: 0px;
}

.order-track-text h5 {
  font-size: 14px;
  font-weight: 600;
  color: #00A19B;
  margin: 0px;
}


p.order-text-schedul {
  font-size: 12px;
  font-weight: 400;
  color: #626262;
  margin: 0px;
}

.order-track-text-stat {
  font-size: 16px;
  color: #00A19B;
  font-weight: 600;
  margin: 0px;
}

.order-track-text-sub {
  font-size: 12px;
  color: #626262;
  font-weight: normal;
  margin: 0px;
}

p.order-track-label {
  font-size: 16px;
  color: #1A1919;
  font-weight: 600;
  margin: 0px;
  margin-top: -6px;
}

img.dot-icon{
  width: 10px;
  margin-left: 11px;
}

p.order-track-processing {
  font-size: 14px;
  color: #1A1919;
  font-weight: 400;
  margin: 0px;
}

.transation-card-otp-wrap {
  width: 151px;
  height: 45px;
  border-radius: 23px;
  background: #F3F3F3;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 24px;
}

.transation-card-otp-wrap p {
  font-size: 14px;
  color: #00A19B;
  font-weight: 600;
  margin: 0px;
}

.transation-cart-status-wrap{
  height: calc(100vh - 600px);
  /* background-color: red; */
  overflow: auto;
  padding-right: 50px;
  border-right: 1px solid #ccc;
}



/************** Chat Masseges Drawer ****/
.replay-chat-box-wrapper {
  position: relative;
  margin-top: 20px;
  width: 100%;
  height: calc(100vh - 600px) !important;
}


/******** Chat Bot Msg *****/
  .msger-chat {
    flex: 1 1;
    overflow-y: auto;
    padding: 20px 20px;
    height: calc(100vh - 600px) !important;
    border-right: 1px solid #ccc;
  }

  .msger-chat::-webkit-scrollbar {
    width: 5px;
    border-radius: 10px;
    
  }

  .msger-chat::-webkit-scrollbar-track {
    background: #ddd;
  }

  .msger-chat::-webkit-scrollbar-thumb {
    background: #00A19B;
  }

  .msg {
    display: flex;
    align-items: flex-end;
  }

  .msg:last-of-type {
    margin: 0;
  }

  .msg-bubble {
    max-width: 450px;
    padding: 15px;
    border-radius: 25px;
    background: #BAE9E9;
}

  .msg-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }

  .msg-info-name {
    font-size: 14px;
    color: #313131;
    font-weight: 500;
    margin-left: 20px;
}

  .msg-info-time {
    font-size: 0.85em;
  }
  

  
  .right-msg {
    flex-direction: row-reverse;
  }

  .right-msg .msg-bubble {
    background: #00A19B;
    color: #fff;
    border-radius: 25px;
  }

  .replay-chat-box-wrap .msg.left-msg .msg-text {
    font-size: 16px;
    color: #1A1919;
    font-weight: 600;
    margin: 0px;
}

.replay-chat-box-wrap .msg .msg-text {
  font-size: 16px;
  color: #FFFFFF;
  font-weight: 600;
  margin: 0px;
}

.chat-right-message-wrap .msg-info-time p {
    font-size: 14px;
    color: #B5B5B5;
    font-weight: 400;
    margin: 0px;
    text-align: right;
    padding-right: 10px;
}

.chat-left-message-wrap .msg-info-time p {
    font-size: 14px;
    color: #B5B5B5;
    font-weight: 400;
    margin: 0px;
    padding-right: 10px;
}

.chat-right-message-wrap{
    margin-bottom: 16px;
}


.right-info-time {
    text-align: right;
}

.left-info-time {
    text-align: left;
}

.right-info-time p, .left-info-time p {
  font-size: 14px;
  color: #B5B5B5;
  font-weight: 400;
  padding-top: 4px;
  margin-left: 20px;
  margin-right: 20px;
}



.chat-send-message-wrapper{
  position: absolute;
  width: 100%;
  bottom: 0px;
}


.chat-send-message-wrap{
  position: relative;
}

.chat-send-message-wrap input {
  width: 100%;
  height: 82px;
  border: 1px solid #DFDFDF;
  border-radius: 42px;
  outline: none;
  padding: 30px;
}

.chat-send-button img {
  width: 65px;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}


.chat-date-divider {
  width: 80%;
  border: 1px solid #E9E9E9;
  height: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  margin-top: 26px;
  margin-bottom: 34px;
}

.chat-date-divider span {
  display: block;
  background: #fff;
  padding: 0px 20px;
  color: #B5B5B5;
  font-size: 14px;
  font-weight: 400;
}


.booking-cart-items-wrap.tracking-cart-item-wrap::-webkit-scrollbar-track {
  background: #ddd;
}

.booking-cart-items-wrap.tracking-cart-item-wrap::-webkit-scrollbar-thumb {
  background: #00A19B;
}

.transation-cart-status-wrap::-webkit-scrollbar-track {
  background: #ddd;
}

.transation-cart-status-wrap::-webkit-scrollbar-thumb {
  background: #00A19B;
}




.empty-conversation-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: calc(100vh - 600px);
}

.empty-conversation-wrap h3 {
  font-size: 22px;
  color: #1A1919;
  font-weight: bold;
  margin: 0px;
}

.empty-conversation-wrap p {
  font-size: 16px;
  color: #1A1919;
  font-weight: 400;
  text-align: center;
  width: 60%;
  padding-top: 10px;
}

.empty-conversation-wrap img {
  width: 120px;
}




.after-before-image-wrap{
  margin-top: 24px;
}

.after-before-image-wrap h3 {
  font-size: 16px;
  color: #1A1919;
  font-weight: 600;
  margin: 0px;
  margin-bottom: 12px;
}

.after-images-wrap{
  width: 248px;
}

.after-images-wrap img {
  width: 100%;
  height: 162px;
  object-fit: cover;
  cursor: pointer;
}

.after-images-wrap{
  margin-bottom: 24px;
}

.after-images-wrap{
  position: relative;
}

.after-button-wrap {
  position: absolute;
  bottom: 10px;
  left: 32%;
  width: 89px;
  height: 32px;
  background: #F3F3F3;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  cursor: pointer;
}

.after-button-wrap p{
  font-size: 12px;
  color: #1A1919;
  font-weight: 500;
  margin: 0px;
}

.after-image-count {
  width: 26px;
  height: 26px;
  background: #00A19B;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: absolute;
  top: -10px;
  right: -10px;
}

.after-image-count p {
  font-size: 12px;
  color: #FFFFFF;
  font-weight: 500;
  margin: 0px;
}

.order-status-customer-review h3 {
  font-size: 16px;
  color: #1A1919;
  font-weight: 600;
  margin: 0px;
  margin-bottom: 18px;
}

.order-status-customer-review p {
  font-size: 14px;
  color: #ACACAC;
  font-weight: 400;
  margin: 0px;
  margin-top: 14px;
}

.after-before-image-wrap{
  display: flex;
  gap: 50px;
}

.transation-complete-image-wrap{
  border-top: 1px dashed #ccc;
  padding-top: 40px;
  margin-left: 56px;
}

.transation-complete-image-wrap h3 {
  font-size: 16px;
  color: #1A1919;
  font-weight: 500;
  margin: 0px;
}

.order-status-customer-review {
  width: 230px;
}

.order-status-customer-review h3{
  font-size: 16px;
  color: #1A1919;
  font-weight: 500;
  margin-bottom: 18px;
}

.transaction-status-btn-wrapper {
  display: flex;
  align-items: center;
  gap: 20px;
}

.tx-status-wrapper-text h3{
  text-align: left !important;
  margin-left: 10px !important;
}

.transaction-status-btn-wrapper button{
  width: 232px;
  height: 70px;
  border: 1px solid #00A19BF7;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 400;
  color: #00A19B;
  background: #F3F3F3;
  outline: none;
}

.transaction-status-btn-wrapper button:hover{
  color: #fff;
  border: 1px solid #00A19BF7;
  background: #00A19BF7;
}

.transation-card-otp-wrap{
  position: relative;
}

span.copied-text {
  position: absolute;
  right: -60px;
  color: #626262;
  font-size: 14px;
  font-weight: 500;
}

.transation-card-otp-wrap img {
  cursor: pointer;
}

a.table-active-td{
  cursor: pointer;
  text-decoration: none;
}

.active-tx-id{
  cursor: pointer;
}

.booking-item-detail h6{
  margin: 0px;
}

.transaction-header-main-wrap{
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.transfer-history-title-wrap{
  display: flex;
  align-items: center;
}

.search-icon img {
  width: 20px;
}

img.table-view-icon:hover{
  scale: 0.9;
  cursor: pointer;
}

.transation-card-otp-wrap img:hover{
  scale: 0.9;
}

p.discount-text{
  color: #FF0000 !important;
}


@media (min-width: 1025px) and (max-width: 1599px) {
  .cleaner-payment-tx-wrap h3 {
    font-size: 22px;
  }

  .cleaner-payment-detail-left p {
    font-size: 18px;
  }

  .invoice-booking-client h3 {
    font-size: 20px;
  }

  .booking-client-detail p {
    font-size: 18px;
  }

  .invoice-booking-industry-wrap {
    margin-top: 40px;
  }

  .booking-cart-items-wrap.tracking-cart-item-wrap {
    height: calc(100vh - 420px);
  }

  .transation-cart-status-wrap {
    height: calc(100vh - 420px);
  }

  .replay-chat-box-wrapper {
    height: calc(100vh - 420px) !important;
  }

  .msger-chat {
      height: calc(100vh - 420px) !important;
  }

  /* .booking-item-detail h6 {
    display: none;
  } */

  .booking-item-detail p {
    font-size: 12px;
    white-space: nowrap;
    /* width: 100px; */
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
  }

  .transation-cart-detail-wrap {
    margin-left: 56px;
    gap: 10px;
}

.replay-chat-box-wrap .msg.left-msg .msg-text {
  font-size: 14px;
}

.replay-chat-box-wrap .msg .msg-text {
  font-size: 14px;
}

.right-info-time p, .left-info-time p {
  font-size: 12px;
}

.transfer-history-header img {
  width: 52px;
}

.transfer-history-header h3 {
  font-size: 28px;
}

.search-icon img {
  width: 20px;
}

p.order-track-label {
  font-size: 14px;
}

.order-track-step {
  height: 65px;
}

.order-track-status-dot {
  margin-left: 10px;
}

}


@media(max-width: 1024px){
  .transation-cart-detail-wrap {
    grid-template-columns: auto;
  }

  .cleaner-payment-tx-wrap h3 {
    font-size: 18px;
  }

  
}


@media (min-width: 1024px) and (max-width: 1199px) {

  .cleaner-payment-tx-wrap h3 {
    font-size: 22px;
  }

  .cleaner-payment-detail-left p {
    font-size: 18px;
  }

  .invoice-booking-client h3 {
    font-size: 20px;
  }

  .booking-client-detail p {
    font-size: 18px;
  }

  .invoice-booking-industry-wrap {
    margin-top: 40px;
  }

  .booking-cart-items-wrap.tracking-cart-item-wrap {
    height: calc(100vh - 420px);
  }

  .transation-cart-status-wrap {
    height: calc(100vh - 420px);
  }

  .replay-chat-box-wrapper {
    height: calc(100vh - 420px) !important;
    margin-top: 0px;
  }

  .msger-chat {
      height: calc(100vh - 420px) !important;
  }

  /* .booking-item-detail h6 {
    display: none;
  } */

  .booking-item-detail p {
    font-size: 12px;
    white-space: nowrap;
    /* width: 80px; */
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left;
  }

  .transation-cart-detail-wrap {
    margin-left: 56px;
    gap: 10px;
}

.replay-chat-box-wrap .msg.left-msg .msg-text {
  font-size: 12px;
}

.replay-chat-box-wrap .msg .msg-text {
  font-size: 12px;
}

.right-info-time p, .left-info-time p {
  font-size: 10px;
}

.transation-cart-item-wrap h4 {
  font-size: 16px;
  margin-bottom: 28px;
}

.transation-cart-header h4 {
  font-size: 16px;
}

.transation-cart-header {
  margin-bottom: 18px;
}

.transation-card-otp-wrap {
  width: 140px;
  height: 40px;
  border-radius: 16px;
}

.transation-card-otp-wrap p {
  font-size: 12px;
}

.transation-card-otp-wrap img {
  width: 12px;
  cursor: pointer;
}

.after-before-image-wrap {
  gap: 40px;
}

.after-images-wrap {
  width: 200px;
}

.order-status-customer-review {
  width: 220px;
}

.order-status-customer-review p {
  font-size: 12px;
}

p.order-track-label {
  font-size: 12px;
}

}
`, "",{"version":3,"sources":["webpack://./src/Dashboard/Transaction/Transaction.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;;GAMG;;;AAGH;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;;AAGA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;;;AAIA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;;AAGA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,8BAA8B;;AAE9B;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;;;AAIA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;EACnB,4BAA4B;AAC9B;;;;AAIA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,sCAAsC;AACxC;;;AAGA,4BAA4B;EAC1B;IACE,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,sCAAsC;IACtC,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,mBAAmB;;EAErB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;EAEE;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;EAEE;IACE,iBAAiB;EACnB;;;;EAIA;IACE,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;;;AAIA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;;AAGA;EACE,UAAU;EACV,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;;;;AAKA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;;;;AAKA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,sCAAsC;EACxC;;EAEA;MACI,sCAAsC;EAC1C;;EAEA;;KAEG;;EAEH;IACE,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,SAAS;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;AAGA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;;AAGF;;;AAGA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,sCAAsC;IACtC,eAAe;EACjB;;EAEA;MACI,sCAAsC;EAC1C;;EAEA;;KAEG;;EAEH;IACE,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,SAAS;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA","sourcesContent":[".wallet-transaction-wrapper {\n  padding-top: 80px;\n}\n\n.wallet-transation-table-wrapper {\n  margin-top: 65px;\n}\n\n.transactin-detail {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  margin-top: 27px;\n}\n\n.transactin-detail h2 {\n  font-size: 34px;\n  color: #383838;\n  margin: 0px;\n}\n\n.transaction-detail-wrapper {\n  display: flex;\n  /* align-items: center; */\n  justify-content: space-between;\n  margin-top: 43px;\n}\n\n.transaction-detail-wrapper span.time {\n  margin-left: 15px;\n}\n\n/* .transaction-detail-wrapper h3 {\n  width: 280px;\n  font-size: 30px;\n  color: #383838;\n  padding-bottom: 10px;\n  border-bottom: 5px solid #fbc425;\n} */\n\n\n.transactin-detail img {\n  width: 35px;\n  cursor: pointer;\n}\n\n.transaction-info-wrapper {\n  margin-top: 36px;\n}\n\n.transaction-info-wrap {\n  display: flex;\n  gap: 90px;\n  padding-bottom: 20px;\n}\n\n.transaction-info-wrap h5 span.highlight-text {\n  color: #00A19B;\n}\n\n.transaction-info-wrap h4 {\n  min-width: 220px;\n  font-size: 24px;\n  color: #383838;\n  margin: 0px;\n}\n\n.transaction-info-wrap h5 {\n  font-size: 24px;\n  color: #5b5b5b;\n  margin: 0px;\n}\n\n.transaction-detail-table-wrapper {\n  margin-top: 100px;\n  overflow-x: auto;\n}\n\n.transaction-total-wrapper {\n  margin-top: 67px;\n  padding-bottom: 50px;\n}\n\n.transaction-total-wrap {\n  display: flex;\n  justify-content: flex-end;\n  gap: 150px;\n  padding-bottom: 20px;\n}\n\n.transaction-total-wrap h4 {\n  min-width: 165px;\n  font-size: 24px;\n  color: #383838;\n  margin: 0px;\n}\n\n.transaction-total-wrap h5 {\n  font-size: 24px;\n  color: #5b5b5b;\n  margin: 0px;\n  min-width: 170px;\n  width: 170px;\n}\n\n.transaction-detail-left {\n  width: 60%;\n}\n\n.transaction-detail-right {\n  width: 40%;\n}\n\n.transaction-with-icon{\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.transaction-with-icon img {\n  width: 30px;\n}\n\n\n.transaction-with-icon img.type-icon-img {\n  width: 36px;\n}\n\n.transaction-banking-info-wrapper {\n  margin-top: 62px;\n}\n\nh5.hyper-link-customer {\n  color: #00A19B;\n  cursor: pointer;\n}\n\n.contact-person-detail h4 {\n  font-size: 16px;\n  color: #00A19B;\n  font-weight: 600;\n  margin: 0px;\n  padding-bottom: 10px;\n}\n\n\n.transation-cart-detail-wrap {\n  margin-left: 56px;\n  border-top: 1px dashed #ccc;\n  padding-top: 40px;\n  padding-bottom: 40px;\n  display: grid;\n  grid-template-columns: auto auto auto;\n  gap: 50px;\n}\n\n.transation-cart-item-wrap h4 {\n  font-size: 18px;\n  font-weight: 700;\n  margin: 0px;\n  color: #1A1919;\n  margin-bottom: 38px;\n}\n\n.cart-sqfeet-wrap {\n  display: flex;\n  justify-content: space-between;\n}\n\n.cart-sqfeet-wrap p{\n  font-size: 14px;\n  color: #1A1919;\n  margin: 0px;\n  font-weight: 400;\n}\n\n\n\n/****************** traking css ******/\n.tranking-booking-cart-item {\n  margin-top: 12px;\n  text-align: right;\n}\n\n\n.booking-item-detail {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n}\n\n.booking-item-detail h6 {\n  font-size: 14px;\n  color: #1A1919;\n  font-weight: 600;\n  margin: 0px;\n}\n\n.booking-item-detail p{\n  font-size: 14px;\n  color: #1A1919;\n  font-weight: 400;\n  margin: 0px;\n}\n\n.booking-item-detail span{\n  font-size: 14px;\n  color: #00A19B;\n  font-weight: 400;\n  margin-top: 2px;\n}\n\n\n.booking-cart-item-repeat {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n\n.tracking-order-main-wrap {\n  margin-top: 45px;\n}\n\n.booking-cart-item-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.booking-cart-item-right {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.booking-item-price-wrap p {\n  font-size: 14px;\n  color: #1A1919;\n  font-weight: 400;\n  margin: 0px;\n  min-width: 60px;\n}\n\n.booking-item-image {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background-color: #f3f3f3;\n  overflow: hidden;\n}\n\n.booking-item-image img {\n  width: 100%;\n  object-fit: cover;\n}\n\n.tracking-address-detail-wrap {\n  width: 100%;\n  height: 402px;\n  border: 2px solid #F8F8F8;\n  border-radius: 34px;\n  padding: 38px 38px;\n  position: relative;\n}\n\n.tracking-address-detail-wrap h4 {\n  font-size: 22px;\n  color: #1A1919;\n  font-weight: 600;\n  margin: 0px;\n}\n\n\n.tracking-selected-services {\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n  gap: 10px;\n}\n\n.tracking-selected-services img{\n  width: 70px;\n}\n\n.tracking-selected-services p {\n  font-size: 14px;\n  color: #00A19B;\n  font-weight: 600;\n  margin: 0px;\n}\n\n\n.traking-detail-address-wrap{\n  margin-top: 46px;\n}\n\n.traking-detail-address-wrap h4 {\n  font-size: 16px;\n  color: #1A1919;\n  font-weight: 600;\n  margin: 0px;\n}\n\n.tranking-address-confrim-icon img {\n  width: 70px;\n}\n\n.tranking-address-confrim-icon {\n  position: absolute;\n  right: 20px;\n  top: 30px;\n}\n\n\n.booking-item-quantity-wrap {\n  width: 95px;\n  height: 24px;\n  border-radius: 12px;\n  background: #F3F3F3;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.booking-item-quantity-wrap p {\n  font-size: 14px;\n  color: #1A1919;\n  font-weight: 600;\n  margin: 0px;\n}\n\n.booking-cart-items-wrap.tracking-cart-item-wrap h5 {\n  font-size: 14px;\n  color: #1A1919;\n  font-weight: 600;\n  margin: 0px;\n  margin-top: 34px;\n  margin-bottom: 13px;\n}\n\n.transation-cart-header h4 {\n  font-size: 18px;\n  color: #1A1919;\n  font-weight: 700;\n  margin: 0px;\n}\n\n.transation-cart-header{\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 28px;\n}\n\n\n.booking-cart-items-wrap.tracking-cart-item-wrap {\n  height: calc(100vh - 600px);\n  /* background-color: red; */\n  overflow: auto;\n  padding-right: 50px;\n  border-right: 1px solid #ccc;\n}\n\n/******** track order css ****/\n\n.order-track-status img {\n  width: 35px;\n  margin-left: -2px;\n  margin-top: -4px;\n}\n\n.order-track-step {\n  display: flex;\n  height: 70px;\n}\n\n\n\n.order-track-long-step{\n  height: 110px;\n}\n\n.order-track-step:last-child .order-track-status span:last-of-type {\n  display: none;\n}\n\n.order-track-status {\n  margin-right: 10px;\n  position: relative;\n  width: 30px;\n}\n\n.order-track-status-dot {\n  display: block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #00A19B;\n  margin-left: 11px;\n  position: inherit;\n}\n\n.order-track-status-line {\n  display: block;\n  margin: 0 auto;\n  width: 0px;\n  height: 70px;\n  margin-top: -10px;\n  border-left: 1px dashed #E1E1E1; \n  background: none;\n}\n\n.order-track-text {\n  display: flex;\n  flex-direction: column;\n  gap: 0px;\n}\n\n.order-track-text h5 {\n  font-size: 14px;\n  font-weight: 600;\n  color: #00A19B;\n  margin: 0px;\n}\n\n\np.order-text-schedul {\n  font-size: 12px;\n  font-weight: 400;\n  color: #626262;\n  margin: 0px;\n}\n\n.order-track-text-stat {\n  font-size: 16px;\n  color: #00A19B;\n  font-weight: 600;\n  margin: 0px;\n}\n\n.order-track-text-sub {\n  font-size: 12px;\n  color: #626262;\n  font-weight: normal;\n  margin: 0px;\n}\n\np.order-track-label {\n  font-size: 16px;\n  color: #1A1919;\n  font-weight: 600;\n  margin: 0px;\n  margin-top: -6px;\n}\n\nimg.dot-icon{\n  width: 10px;\n  margin-left: 11px;\n}\n\np.order-track-processing {\n  font-size: 14px;\n  color: #1A1919;\n  font-weight: 400;\n  margin: 0px;\n}\n\n.transation-card-otp-wrap {\n  width: 151px;\n  height: 45px;\n  border-radius: 23px;\n  background: #F3F3F3;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-bottom: 24px;\n}\n\n.transation-card-otp-wrap p {\n  font-size: 14px;\n  color: #00A19B;\n  font-weight: 600;\n  margin: 0px;\n}\n\n.transation-cart-status-wrap{\n  height: calc(100vh - 600px);\n  /* background-color: red; */\n  overflow: auto;\n  padding-right: 50px;\n  border-right: 1px solid #ccc;\n}\n\n\n\n/************** Chat Masseges Drawer ****/\n.replay-chat-box-wrapper {\n  position: relative;\n  margin-top: 20px;\n  width: 100%;\n  height: calc(100vh - 600px) !important;\n}\n\n\n/******** Chat Bot Msg *****/\n  .msger-chat {\n    flex: 1;\n    overflow-y: auto;\n    padding: 20px 20px;\n    height: calc(100vh - 600px) !important;\n    border-right: 1px solid #ccc;\n  }\n\n  .msger-chat::-webkit-scrollbar {\n    width: 5px;\n    border-radius: 10px;\n    \n  }\n\n  .msger-chat::-webkit-scrollbar-track {\n    background: #ddd;\n  }\n\n  .msger-chat::-webkit-scrollbar-thumb {\n    background: #00A19B;\n  }\n\n  .msg {\n    display: flex;\n    align-items: flex-end;\n  }\n\n  .msg:last-of-type {\n    margin: 0;\n  }\n\n  .msg-bubble {\n    max-width: 450px;\n    padding: 15px;\n    border-radius: 25px;\n    background: #BAE9E9;\n}\n\n  .msg-info {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n  }\n\n  .msg-info-name {\n    font-size: 14px;\n    color: #313131;\n    font-weight: 500;\n    margin-left: 20px;\n}\n\n  .msg-info-time {\n    font-size: 0.85em;\n  }\n  \n\n  \n  .right-msg {\n    flex-direction: row-reverse;\n  }\n\n  .right-msg .msg-bubble {\n    background: #00A19B;\n    color: #fff;\n    border-radius: 25px;\n  }\n\n  .replay-chat-box-wrap .msg.left-msg .msg-text {\n    font-size: 16px;\n    color: #1A1919;\n    font-weight: 600;\n    margin: 0px;\n}\n\n.replay-chat-box-wrap .msg .msg-text {\n  font-size: 16px;\n  color: #FFFFFF;\n  font-weight: 600;\n  margin: 0px;\n}\n\n.chat-right-message-wrap .msg-info-time p {\n    font-size: 14px;\n    color: #B5B5B5;\n    font-weight: 400;\n    margin: 0px;\n    text-align: right;\n    padding-right: 10px;\n}\n\n.chat-left-message-wrap .msg-info-time p {\n    font-size: 14px;\n    color: #B5B5B5;\n    font-weight: 400;\n    margin: 0px;\n    padding-right: 10px;\n}\n\n.chat-right-message-wrap{\n    margin-bottom: 16px;\n}\n\n\n.right-info-time {\n    text-align: right;\n}\n\n.left-info-time {\n    text-align: left;\n}\n\n.right-info-time p, .left-info-time p {\n  font-size: 14px;\n  color: #B5B5B5;\n  font-weight: 400;\n  padding-top: 4px;\n  margin-left: 20px;\n  margin-right: 20px;\n}\n\n\n\n.chat-send-message-wrapper{\n  position: absolute;\n  width: 100%;\n  bottom: 0px;\n}\n\n\n.chat-send-message-wrap{\n  position: relative;\n}\n\n.chat-send-message-wrap input {\n  width: 100%;\n  height: 82px;\n  border: 1px solid #DFDFDF;\n  border-radius: 42px;\n  outline: none;\n  padding: 30px;\n}\n\n.chat-send-button img {\n  width: 65px;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n}\n\n\n.chat-date-divider {\n  width: 80%;\n  border: 1px solid #E9E9E9;\n  height: 0px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  margin-top: 26px;\n  margin-bottom: 34px;\n}\n\n.chat-date-divider span {\n  display: block;\n  background: #fff;\n  padding: 0px 20px;\n  color: #B5B5B5;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n\n.booking-cart-items-wrap.tracking-cart-item-wrap::-webkit-scrollbar-track {\n  background: #ddd;\n}\n\n.booking-cart-items-wrap.tracking-cart-item-wrap::-webkit-scrollbar-thumb {\n  background: #00A19B;\n}\n\n.transation-cart-status-wrap::-webkit-scrollbar-track {\n  background: #ddd;\n}\n\n.transation-cart-status-wrap::-webkit-scrollbar-thumb {\n  background: #00A19B;\n}\n\n\n\n\n.empty-conversation-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  height: calc(100vh - 600px);\n}\n\n.empty-conversation-wrap h3 {\n  font-size: 22px;\n  color: #1A1919;\n  font-weight: bold;\n  margin: 0px;\n}\n\n.empty-conversation-wrap p {\n  font-size: 16px;\n  color: #1A1919;\n  font-weight: 400;\n  text-align: center;\n  width: 60%;\n  padding-top: 10px;\n}\n\n.empty-conversation-wrap img {\n  width: 120px;\n}\n\n\n\n\n.after-before-image-wrap{\n  margin-top: 24px;\n}\n\n.after-before-image-wrap h3 {\n  font-size: 16px;\n  color: #1A1919;\n  font-weight: 600;\n  margin: 0px;\n  margin-bottom: 12px;\n}\n\n.after-images-wrap{\n  width: 248px;\n}\n\n.after-images-wrap img {\n  width: 100%;\n  height: 162px;\n  object-fit: cover;\n  cursor: pointer;\n}\n\n.after-images-wrap{\n  margin-bottom: 24px;\n}\n\n.after-images-wrap{\n  position: relative;\n}\n\n.after-button-wrap {\n  position: absolute;\n  bottom: 10px;\n  left: 32%;\n  width: 89px;\n  height: 32px;\n  background: #F3F3F3;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 16px;\n  cursor: pointer;\n}\n\n.after-button-wrap p{\n  font-size: 12px;\n  color: #1A1919;\n  font-weight: 500;\n  margin: 0px;\n}\n\n.after-image-count {\n  width: 26px;\n  height: 26px;\n  background: #00A19B;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  position: absolute;\n  top: -10px;\n  right: -10px;\n}\n\n.after-image-count p {\n  font-size: 12px;\n  color: #FFFFFF;\n  font-weight: 500;\n  margin: 0px;\n}\n\n.order-status-customer-review h3 {\n  font-size: 16px;\n  color: #1A1919;\n  font-weight: 600;\n  margin: 0px;\n  margin-bottom: 18px;\n}\n\n.order-status-customer-review p {\n  font-size: 14px;\n  color: #ACACAC;\n  font-weight: 400;\n  margin: 0px;\n  margin-top: 14px;\n}\n\n.after-before-image-wrap{\n  display: flex;\n  gap: 50px;\n}\n\n.transation-complete-image-wrap{\n  border-top: 1px dashed #ccc;\n  padding-top: 40px;\n  margin-left: 56px;\n}\n\n.transation-complete-image-wrap h3 {\n  font-size: 16px;\n  color: #1A1919;\n  font-weight: 500;\n  margin: 0px;\n}\n\n.order-status-customer-review {\n  width: 230px;\n}\n\n.order-status-customer-review h3{\n  font-size: 16px;\n  color: #1A1919;\n  font-weight: 500;\n  margin-bottom: 18px;\n}\n\n.transaction-status-btn-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.tx-status-wrapper-text h3{\n  text-align: left !important;\n  margin-left: 10px !important;\n}\n\n.transaction-status-btn-wrapper button{\n  width: 232px;\n  height: 70px;\n  border: 1px solid #00A19BF7;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 22px;\n  font-weight: 400;\n  color: #00A19B;\n  background: #F3F3F3;\n  outline: none;\n}\n\n.transaction-status-btn-wrapper button:hover{\n  color: #fff;\n  border: 1px solid #00A19BF7;\n  background: #00A19BF7;\n}\n\n.transation-card-otp-wrap{\n  position: relative;\n}\n\nspan.copied-text {\n  position: absolute;\n  right: -60px;\n  color: #626262;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.transation-card-otp-wrap img {\n  cursor: pointer;\n}\n\na.table-active-td{\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.active-tx-id{\n  cursor: pointer;\n}\n\n.booking-item-detail h6{\n  margin: 0px;\n}\n\n.transaction-header-main-wrap{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.transfer-history-title-wrap{\n  display: flex;\n  align-items: center;\n}\n\n.search-icon img {\n  width: 20px;\n}\n\nimg.table-view-icon:hover{\n  scale: 0.9;\n  cursor: pointer;\n}\n\n.transation-card-otp-wrap img:hover{\n  scale: 0.9;\n}\n\np.discount-text{\n  color: #FF0000 !important;\n}\n\n\n@media (min-width: 1025px) and (max-width: 1599px) {\n  .cleaner-payment-tx-wrap h3 {\n    font-size: 22px;\n  }\n\n  .cleaner-payment-detail-left p {\n    font-size: 18px;\n  }\n\n  .invoice-booking-client h3 {\n    font-size: 20px;\n  }\n\n  .booking-client-detail p {\n    font-size: 18px;\n  }\n\n  .invoice-booking-industry-wrap {\n    margin-top: 40px;\n  }\n\n  .booking-cart-items-wrap.tracking-cart-item-wrap {\n    height: calc(100vh - 420px);\n  }\n\n  .transation-cart-status-wrap {\n    height: calc(100vh - 420px);\n  }\n\n  .replay-chat-box-wrapper {\n    height: calc(100vh - 420px) !important;\n  }\n\n  .msger-chat {\n      height: calc(100vh - 420px) !important;\n  }\n\n  /* .booking-item-detail h6 {\n    display: none;\n  } */\n\n  .booking-item-detail p {\n    font-size: 12px;\n    white-space: nowrap;\n    /* width: 100px; */\n    text-overflow: ellipsis;\n    overflow: hidden;\n    text-align: left;\n  }\n\n  .transation-cart-detail-wrap {\n    margin-left: 56px;\n    gap: 10px;\n}\n\n.replay-chat-box-wrap .msg.left-msg .msg-text {\n  font-size: 14px;\n}\n\n.replay-chat-box-wrap .msg .msg-text {\n  font-size: 14px;\n}\n\n.right-info-time p, .left-info-time p {\n  font-size: 12px;\n}\n\n.transfer-history-header img {\n  width: 52px;\n}\n\n.transfer-history-header h3 {\n  font-size: 28px;\n}\n\n.search-icon img {\n  width: 20px;\n}\n\np.order-track-label {\n  font-size: 14px;\n}\n\n.order-track-step {\n  height: 65px;\n}\n\n.order-track-status-dot {\n  margin-left: 10px;\n}\n\n}\n\n\n@media(max-width: 1024px){\n  .transation-cart-detail-wrap {\n    grid-template-columns: auto;\n  }\n\n  .cleaner-payment-tx-wrap h3 {\n    font-size: 18px;\n  }\n\n  \n}\n\n\n@media (min-width: 1024px) and (max-width: 1199px) {\n\n  .cleaner-payment-tx-wrap h3 {\n    font-size: 22px;\n  }\n\n  .cleaner-payment-detail-left p {\n    font-size: 18px;\n  }\n\n  .invoice-booking-client h3 {\n    font-size: 20px;\n  }\n\n  .booking-client-detail p {\n    font-size: 18px;\n  }\n\n  .invoice-booking-industry-wrap {\n    margin-top: 40px;\n  }\n\n  .booking-cart-items-wrap.tracking-cart-item-wrap {\n    height: calc(100vh - 420px);\n  }\n\n  .transation-cart-status-wrap {\n    height: calc(100vh - 420px);\n  }\n\n  .replay-chat-box-wrapper {\n    height: calc(100vh - 420px) !important;\n    margin-top: 0px;\n  }\n\n  .msger-chat {\n      height: calc(100vh - 420px) !important;\n  }\n\n  /* .booking-item-detail h6 {\n    display: none;\n  } */\n\n  .booking-item-detail p {\n    font-size: 12px;\n    white-space: nowrap;\n    /* width: 80px; */\n    text-overflow: ellipsis;\n    overflow: hidden;\n    text-align: left;\n  }\n\n  .transation-cart-detail-wrap {\n    margin-left: 56px;\n    gap: 10px;\n}\n\n.replay-chat-box-wrap .msg.left-msg .msg-text {\n  font-size: 12px;\n}\n\n.replay-chat-box-wrap .msg .msg-text {\n  font-size: 12px;\n}\n\n.right-info-time p, .left-info-time p {\n  font-size: 10px;\n}\n\n.transation-cart-item-wrap h4 {\n  font-size: 16px;\n  margin-bottom: 28px;\n}\n\n.transation-cart-header h4 {\n  font-size: 16px;\n}\n\n.transation-cart-header {\n  margin-bottom: 18px;\n}\n\n.transation-card-otp-wrap {\n  width: 140px;\n  height: 40px;\n  border-radius: 16px;\n}\n\n.transation-card-otp-wrap p {\n  font-size: 12px;\n}\n\n.transation-card-otp-wrap img {\n  width: 12px;\n  cursor: pointer;\n}\n\n.after-before-image-wrap {\n  gap: 40px;\n}\n\n.after-images-wrap {\n  width: 200px;\n}\n\n.order-status-customer-review {\n  width: 220px;\n}\n\n.order-status-customer-review p {\n  font-size: 12px;\n}\n\np.order-track-label {\n  font-size: 12px;\n}\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
